import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {useHistory, useLocation, useParams} from "react-router-dom";

import axios from 'axios';

const NewPasswordPage = (props) => {
  const {t} = props;
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const {hash: activationHash} = useParams();

  const validate = (data) => {
    let errors = {};
    if (!data.newPassword) {
      errors.newPassword = 'Az új jelszó megadása kötelező.';
    } else {
      if (data.newPassword.length < 8) {
        errors.newPassword = 'A jelszónak legalább 8 karakter hosszúnak kell lennie.';
      } else if (!/[a-z]/.test(data.newPassword)) {
        errors.newPassword = 'A jelszónak tartalmaznia kell kisbetűt.';
      } else if (!/[A-Z]/.test(data.newPassword)) {
        errors.newPassword = 'A jelszónak tartalmaznia kell nagybetűt.';
      } else if (!/[0-9]/.test(data.newPassword)) {
        errors.newPassword = 'A jelszónak tartalmaznia kell számot.';
      }
    }
    if (!data.newPasswordConfirm) {
      errors.newPasswordConfirm = 'A jelszó megerősítése kötelező.';
    } else if (
      data.newPassword &&
      data.newPasswordConfirm &&
      data.newPassword !== data.newPasswordConfirm
    ) {
      errors.newPasswordConfirm = 'A két jelszó nem egyezik.';
    }
    return errors;
  };

  const onSubmit = (data, form) => {
    const params = new URLSearchParams(location.search);
    const hash = activationHash || params.get('hash') || '';
    setLoading(true);
    const isActivation = !!activationHash;
    axios.post(process.env.REACT_APP_API_HOST + (isActivation
      ? '/api/v2/user/activation/' + encodeURIComponent(hash)
      : '/api/v2/new-password'), isActivation ? {
      password: data.newPassword
    } : {
      new_password: data.newPassword,
      hash: hash
    })
      .then(() => {
        window.App.toastShow('success', 'Sikeres jelszó beállítás!', 'Az új jelszóval be kell jelentkezni.');
        history.push('/login');
      })
      .catch((error) => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
    form.restart();
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);

  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    document.title = t('newPasswordSetup') + ' - ' + process.env.REACT_APP_TITLE;
    document.getElementById('body').classList.add('outside');
  }, []);

  return (
    <div className="LoginPage p-component p-p-3">
      <img src={require("../.." + process.env.REACT_APP_LOGO_FILE).default} className="p-d-block p-my-5 p-mx-auto"/>
      <Panel headerTemplate={
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4 p-xl-6"}>
            <h3>
              <i className={"pi pi-lock"}></i> {t('newPasswordSetup')}
            </h3>
          </div>
        </div>
      }>
        <Form
          onSubmit={onSubmit}
          className="p-d-block p-mt-5 p-mx-auto"
          validate={validate}
          render={({handleSubmit, submitting, values}) => (
            <form onSubmit={handleSubmit}>
              <div className={"p-grid"}>
                <div className={"p-col-12"}>
                  <Field
                    name="newPassword"
                    render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label
                          htmlFor="newPassword"
                          className={classNames({'p-error': isFormFieldValid(meta)})}
                        >
                          {t('newPassword')}
                        </label>
                        <Password
                          id="newPassword"
                          {...input}
                          toggleMask
                          feedback={false}
                          className={classNames({'p-invalid': isFormFieldValid(meta)})}
                        />
                        {getFormErrorMessage(meta)}
                      </div>
                    )}
                  />
                </div>
                <div className={"p-col-12"}>
                  <Field
                    name="newPasswordConfirm"
                    render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label
                          htmlFor="newPasswordConfirm"
                          className={classNames({'p-error': isFormFieldValid(meta)})}
                        >
                          {t('newPasswordConfirm')}
                        </label>
                        <Password
                          id="newPasswordConfirm"
                          {...input}
                          toggleMask
                          feedback={false}
                          className={classNames({'p-invalid': isFormFieldValid(meta)})}
                        />
                        {getFormErrorMessage(meta)}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className={"p-grid p-mt-2"}>
                <div className={"p-col-12 p-text-right"}>
                  <Button
                    type="submit"
                    label={t('setPassword')}
                    className="p-button-success"
                    icon={"pi pi-check"}
                    loading={loading}
                    disabled={submitting}
                  />
                </div>
              </div>
            </form>
          )}
        />
      </Panel>
    </div>
  );
};

export default withTranslation('common')(NewPasswordPage);
